import { styled } from '../../../../../modules';

type CalloutMode = 'info' | 'default';

export const Card = styled.div<{ $mode: CalloutMode; $accentColor?: string }>`
    width: 100%;
    border-radius: 16px;
    padding: 20px 20px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    text-align: center;
    background-color: ${({ $mode, $accentColor }) =>
        $mode === 'info' ? `${$accentColor || '#0e3573'}14` : '#f9f9f9'};
    border: 1px solid ${({ $mode, $accentColor }) =>
        $mode === 'info' ? `${$accentColor || '#0e3573'}33` : '#e5e5e5'};
    box-shadow: 0 4px 16px ${({ $mode, $accentColor }) =>
        $mode === 'info' ? `${$accentColor || '#0e3573'}1a` : 'rgba(0,0,0,0.06)'};
`;

export const Title = styled.p<{ $mode: CalloutMode; $accentColor?: string }>`
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    color: ${({ $mode, $accentColor }) =>
        $mode === 'info' ? ($accentColor || '#0e3573') : '#a6a6a6'};
`;

export const Description = styled.p<{ $mode: CalloutMode; $accentColor?: string }>`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ $mode, $accentColor }) =>
        $mode === 'info' ? ($accentColor || '#0e3573') : '#525866'};
`;
